import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Souscripteur } from '../models/souscripteur.model';
import { Observable } from 'rxjs/Observable';
import Api from '../../common/services/api.service';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class MainService {
    private endpoint = '/sonavie/client/souscripteurs/';
    //private endpoint = 'http://192.168.1.101:8000/sonavie/client/souscripteurs'; // 192.168.1.229 or localhost
    constructor(private api: Api) { }
    getSouscripteur(id: string): Observable<Souscripteur> {
         return this.api.get(this.endpoint + id);
    }

}



// WEBPACK FOOTER //
// ./src/app/client-app/services/main.service.ts